import { render } from "./wallet_item.vue?vue&type=template&id=21d4e69e&scoped=true"
import script from "./wallet_item.vue?vue&type=script&lang=js"
export * from "./wallet_item.vue?vue&type=script&lang=js"

import "./wallet_item.vue?vue&type=style&index=0&id=21d4e69e&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d4e69e"]])

export default __exports__